import styled from 'styled-components';
import ArticleOutline from '@simplywallst/ui-core/icons/ArticleOutline';
import MarketInsightsOutline from '@simplywallst/ui-core/icons/MarketInsightsOutline';
import { media } from '@simplywallst/ui-core';

export const RecommendedArticleWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  ${media.lgUp`
    margin-top: ${({ theme }) => theme.x9spacePx}px;
  `}
  h3 {
    display: inline-flex;
    align-items: center;
    padding-bottom: ${({ theme }) => theme.x1spacePx}px;
    ${media.mdDown`
      padding-left: 0;
    `}
    > svg {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-right: ${({ theme }) => theme.x1spacePx}px;
      padding: ${({ theme }) => theme.x1spacePx}px;
      border-radius: ${({ theme }) => theme.x1spacePx}px;
    }
  }
`;

export const RecommendedArticleItem = styled('div')`
  padding: ${({ theme }) =>
    `${theme.x1spacePx}px ${theme.x1spacePx}px ${theme.x3spacePx}px ${theme.x3spacePx}px`};
  ${media.mdDown`
      padding-left: 0;
    `}
  &:hover {
    background-color: ${(props) => props.theme.color.darkGrayRGBA(0.1)};
    border-radius: ${({ theme }) => theme.x1spacePx}px;
  }
  > a {
    ${({ theme }) => theme.typography.largeStrong};
    color: ${(props) => props.theme.color.noir};
    text-decoration: none;
    display: block;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const StyledLink = styled('a')`
  ${({ theme }) => theme.typography.xSmall}
  color: ${(props) => props.theme.color.spaceGrayRGBA(0.7)};
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.color.brand01RGBA(0.8)};
    text-decoration: underline;
  }
`;

export const StyledArticleOutline = styled(ArticleOutline)`
  background-color: ${({ theme }) => theme.color.brand01};
`;

export const StyledMarketInsightsOutline = styled(MarketInsightsOutline)`
  background-color: ${({ theme }) => theme.color.chart02};
`;
